import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableContainer,
  TablePagination,
  Typography,
  TextField,

} from "@mui/material";
import MuiTableCell from "@material-ui/core/TableCell";
import MuiTableHead from "@mui/material/TableHead";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import "moment/locale/vi";
import axiosInstance from "../../components/axiosApi";
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import AddRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { useTheme } from "@mui/material/styles";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import SearchIcon from '@mui/icons-material/Search';
import { CustomButton } from "../../components/Common/CustomButton";
import ZaloChat from "./ZaloChat";

import PropTypes from "prop-types";

import blank from "../../assets/images/logo.png";
import label_new from "../../assets/images/new.png";
const URL = `${process.env.REACT_APP_API_URL}`;

const useStyles = makeStyles((theme) => ({
  tableBorder: {
    border: "1px solid #d4d8dd",
    borderRadius: "0.5rem",
    marginTop:'15px'
  },
}));

const TableCell = withStyles({
  root: {
    borderBottom: "1px solid rgb(235, 237, 242)",
    padding: "13px 10px",
    lineHeight: "18px",
  },
})(MuiTableCell);

const TableHead = withStyles((theme) => ({
  root: {
    backgroundColor: "rgba(38,60,85,.1)",
  },
}))(MuiTableHead);

const TableHeaderCell = withStyles((theme) => ({
  root: {
    color: "#516377",
    fontWeight: 700,
    padding: 10,
    fontSize: ".75rem",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
  },
}))(TableCell);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const ZaloTableFollow = ({ data }) => {
  const [loading, setLoading] = useState(true);
  const [showData, setShowData] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const [openChat, setOpenChat] = useState(false);
  const [dataPagination, setDataPagination] = useState({
    offset: 0,
    limit: 10,
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState();

  const [dataFollowList, setDataFollowList] = useState([]);
  const [selected, setSelected] = React.useState([]);
  const [idOA, setIDOA] = React.useState([]);
  const classes = useStyles();
  const [search, setSearch] = useState('')

  
  useEffect(() => {
    if(activeIndex === 0 && data?.zaloOA?.length > 0){
      
        const idOaFirst = data?.zaloOA[0];
          // setIDOA(idOaFirst.id);
          setShowData(!showData);
          handleOpenFollowList(idOaFirst.id);
          setIDOA(idOaFirst.id);
    }
     // setIDOA(idOaFirst.id);
  }, [data?.zaloOA]);



  useEffect(() => {
    if (dataFollowList?.open_leads?.open_leads) {
      setRows([...dataFollowList?.open_leads?.open_leads]);
    }
  }, [dataFollowList.open_leads, search]);

  const handleChangePage = (event, newPage) => {
    let data = {
      offset: newPage * rowsPerPage,
      limit: rowsPerPage,
    };
    handleOpenFollowList(idOA);
    setDataPagination(data);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    let data = {
      offset: page,
      limit: event.target.value !== "-1" ? +event.target.value : 9999,
    };
    handleOpenFollowList(idOA);
    setDataPagination(data);
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
    handleOpenFollowList(idOA);
  }

  const handleOpenFollowList = async (idOA) => {
    let params = "";
    params += `&name=${search}&limit=${dataPagination.limit}&offset=${dataPagination.offset}`;
    try {
      const res = await axiosInstance.get(`/zalo/users/${idOA}/?${params}`);
      if (res.status === 200) {
        setDataFollowList(res.data);
      }
    } catch (error) {}
  };


  
  
  
  const openAccordion = (currentIndex, idOA) => {
    
    setActiveIndex(activeIndex === currentIndex ? null : currentIndex);
    setShowData(!showData);
    handleOpenFollowList(idOA);
    setSearch('')
  };



  return (
    <>
     {
      data?.zaloOA?.length > 0 ? 
      <>
      {openChat ? (
        <>
        <CustomButton style={{marginBottom:'15px',minWidth:'inherit',pading:'0 6px'}} onClick={() => setOpenChat(false)}><KeyboardArrowLeft /></CustomButton>
        <ZaloChat 
          item={selected} 
          idOA={idOA}
          loading={loading}
            setLoading={setLoading}
        />
        </>
      ) : (
        <>
        <Paper sx={{ width: "100%", mb: 2 }} elevation={0}>
        {data?.zaloOA &&
          data?.zaloOA.map((item, index) => (
            <>
            <div
              key={index}
              className="heading"
              style={{
                cursor: "pointer",
                padding: "5px",
                border: "1px solid #D7DFE3",
                borderRadius: "0.5rem",
              }}
              onClick={() => {
                openAccordion(index,item?.id);
                setIDOA(item?.id)
                
              }}
            >
              {
                activeIndex !== index ? 
                <AddRoundedIcon
                style={{ color: "#D7DFE3", marginRight: "5px" }}
              /> :
              <RemoveCircleOutlineRoundedIcon
                style={{ color: "#D7DFE3", marginRight: "5px" }}
              />
              }

              {item?.oa_name}
            </div>


            {activeIndex === index &&  (
            <>
            <div className={activeIndex === index ? 'display' : 'hidden'}>
            <div className="text-right">
            <TextField
              name="email"
              variant="outlined"
              fullWidth
              placeholder="Search theo tên"
              size="small"
              style = {{width: 270}}
              value={search}
              onChange={handleChangeSearch}
            />
            </div>
            
            <Paper
              sx={{ width: "100%", mb: 2 }}
              elevation={0}
              className={`${classes.tableBorder}`}
            >
            
              <TableContainer
                style={{
                  width: "100%",
                  overflowX: "auto",
                  borderRadius: "0.5rem",
                }}
              >
                <Table sx={{ minWidth: 700 }} size={"small"}>
                  <TableHead>
                    <TableRow>
                      <TableHeaderCell align="left">ID</TableHeaderCell>

                      <TableHeaderCell align="left" style={{ minWidth: 120 }}>
                        Avatar
                      </TableHeaderCell>
                      <TableHeaderCell align="left" style={{ minWidth: 120 }}>
                        TÊN ZALO
                      </TableHeaderCell>
                      <TableHeaderCell align="left" style={{ minWidth: 120 }}>
                        NGÀY TẠO
                      </TableHeaderCell>
                      <TableHeaderCell align="left" style={{ minWidth: 50 }}>
                        Action
                      </TableHeaderCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {dataFollowList?.open_leads?.open_leads &&
                      dataFollowList?.open_leads?.open_leads.length > 0 &&
                      dataFollowList?.open_leads?.open_leads.map(
                        (item) => {
                          const today = new Date();
                          const formatToday = moment(today).format(
                          "MM/DD/YYYY")
                        
                          return (
                            <TableRow
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="left">{item?.id}</TableCell>
                              <TableCell align="left">
                                <div className="zalo-logo">
                                  <img
                                    src={item?.zimg ? `${item?.zimg}` : blank}
                                    alt=""
                                  />
                                </div>
                              </TableCell>
                              <TableCell align="left">
                                {item?.zaloName}
                              </TableCell>

                              <TableCell align="left">
                                
                                <div style={{position:'relative',display:'inline-block'}}>
                                {
                                  formatToday === moment(item?.createdate).format(
                                      "MM/DD/YYYY"
                                    ) ?
                                    <img src={label_new} 
                                    style={{position:'absolute', left:'-20px', top:'-12px', width:'40px'}}

                                    />
                                  : null
                                }
                                {item?.created_on === null
                                  ? ""
                                  : moment(item?.createdate).format(
                                      "MM/DD/YYYY"
                                    )}
                                </div>
                              </TableCell>
                              <TableCell align="left">
                                <div
                                  className="zalo-icon"
                                  onClick={() => 
                                    {setOpenChat(true);
                                    setSelected(item);
                                    }
                                    }
                                >
                                  <svg
                                    style={{ transform: "scale(0.05)" }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    enableBackground="new 0 0 30 30"
                                    overflow="visible"
                                    version="1.1"
                                    viewBox="0 0 30 30"
                                    xmlSpace="preserve"
                                  >
                                    <g
                                      fill="#0EA9E0"
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                    >
                                      <path d="M448.178 12.69c-6.376 0-11.46 1.293-15.29 6.369-3.792 3.785-6.33 8.853-6.33 15.221v166.692c0 6.321 2.538 11.397 6.33 15.228 3.83 5.069 8.914 6.361 15.29 6.361 5.084 0 10.16-1.292 15.244-6.361 3.83-3.83 5.084-8.906 5.084-15.228V34.28c0-6.369-1.254-11.437-5.084-15.221-5.084-5.076-10.16-6.369-15.244-6.369zm125.975 162.778c-5.084 6.322-11.413 10.236-20.328 10.236-8.914 0-16.536-3.914-21.62-10.236-5.084-7.652-7.622-16.514-7.622-26.704 0-10.152 2.538-17.758 7.622-25.372 5.084-6.453 12.706-10.284 21.62-10.284 8.915 0 15.244 3.831 20.328 10.284 6.499 7.614 9.045 15.22 9.045 25.372 0 10.19-2.546 19.051-9.045 26.704zm31.911-80.119c-13.998-15.221-31.911-22.881-52.239-22.881-21.62 0-38.155 7.661-52.154 21.59-12.706 15.267-19.167 33.157-19.167 54.707 0 21.589 6.461 40.771 19.167 54.747 13.999 15.221 30.534 22.836 52.154 22.836 20.328 0 38.241-7.615 52.239-22.836 12.706-13.976 19.082-33.158 19.082-54.747 0-21.551-6.375-39.441-19.082-53.416zm-247.043 80.119c-5.075 6.322-12.706 10.236-21.619 10.236-8.868 0-16.49-3.914-21.621-10.236-5.168-7.652-7.706-16.514-7.706-26.704 0-10.152 2.538-17.758 7.706-25.372 5.131-6.453 12.753-10.284 21.621-10.284 8.913 0 16.543 3.831 21.619 10.284 5.084 7.614 7.668 15.22 7.668 25.372-.001 10.19-2.585 19.051-7.668 26.704zm27.996-100.462c-8.914 0-15.244 5.122-19.082 13.975-8.914-11.438-21.62-16.514-36.864-16.514-17.828 0-34.456 7.661-45.908 22.881-12.706 13.975-19.083 31.865-19.083 53.415 0 21.589 6.376 39.479 19.083 54.747 11.452 15.221 28.081 22.836 45.908 22.836 15.244 0 27.95-6.361 36.864-16.515 3.838 8.899 10.168 12.729 19.082 12.729 6.376 0 11.461-1.292 15.376-6.361 3.792-3.83 6.329-8.906 6.329-15.228V96.594c0-5.077-2.537-10.146-6.329-15.222-3.915-3.829-9-6.366-15.376-6.366zM226.67 0H26.704C11.414 0 0 11.445 0 26.666V221.27c0 13.982 11.414 25.504 26.704 25.504H63.7v31.742c0 2.539 3.791 2.539 5.083 1.291 11.41-10.152 44.49-33.033 44.49-33.033H226.67c13.998 0 25.458-11.521 25.458-25.504v-5.069c-6.376 5.069-15.291 6.361-15.291 6.361H104.355c-7.622 0-20.329-3.83-22.866-16.513-1.296-12.73 5.08-17.806 5.08-17.806l81.485-110.7h-61.115s-22.913-1.246-22.913-28.042c0-26.658 26.705-26.658 26.705-26.658h127.398c6.331 0 10.16 1.284 13.999 3.822C252.128 11.445 240.668 0 226.67 0zm8.922 171.646c7.614 0 12.698 1.285 16.536 5.067V58.539l-82.781 113.107h66.245zM665.933 41.895C641.682 8.907 603.526 12.69 603.526 12.69s-3.831 2.539-3.831 5.076c1.285 3.823 3.831 3.823 3.831 3.823s33.08-3.823 54.699 25.381c20.453 26.79 16.623 50.917 15.377 52.163 0 2.584 2.538 6.368 5.076 6.368 3.791 0 5.084-5.076 5.084-5.076s3.792-27.958-17.829-58.53zm-61.114-6.323s-5.124 1.247-5.124 3.784c0 3.824 3.831 5.077 3.831 5.077s24.158-2.539 36.865 14.105c13.998 16.467 12.751 39.349 12.751 40.595 0 2.584 1.247 5.114 3.793 5.114 3.828 0 5.074-3.822 5.074-3.822s1.385-26.666-13.996-45.718c-15.243-20.427-43.194-19.135-43.194-19.135zm2.537 20.429s-5.122 0-5.122 5.076c1.292 2.53 3.83 5.069 3.83 5.069s15.251 0 21.62 10.152c5.085 8.899 3.839 20.298 3.839 20.298s1.246 5.122 3.791 5.122c3.831 1.246 6.367-3.83 6.367-3.83s1.255-13.976-7.62-26.666c-8.915-13.975-26.705-15.221-26.705-15.221z"></path>
                                    </g>
                                  </svg>
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[10, 25, { label: "All", value: -1 }]}
                  colSpan={3}
                  labelRowsPerPage={"Số hàng trên 1 trang:"}
                  count={dataFollowList?.open_leads?.leads_count}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableContainer>
            </Paper>
            </div>
            </>
          ) }

          </>
          ))}
      </Paper>
          
        </>
      )}
      </> : <Typography>Cần kết nối ZaloOA trước</Typography>
     } 

      
    </>
  );
};

export default ZaloTableFollow;
